import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('user', { startValue: undefined });
